import type * as React from 'react'

import { cn } from '@/shared/lib/cn'

function Label({ className, ...props }: React.ComponentProps<'label'>) {
  return (
    <label
      data-slot="label"
      className={cn(
        'flex items-center gap-2 [font-size:var(--type-label-font-size)] [font-weight:var(--type-label-font-weight)] [line-height:var(--type-label-line-height)] select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 peer-[[data-disabled]]:opacity-50',
        className
      )}
      {...props}
    />
  )
}

export { Label }
